<template>
	<div id="companyAttributes"  class="public-content" v-loading="gobleLoading">
		<!-- 公共form表单样式 -->
		<div class="form-item-public">
			<el-form label-width="265px" label-position="right" :model="formData"  ref="companyRef" :inline="true">
				<el-form-item label="公司名称：">
					<el-input v-model="formData.bookName" size="small"
							  :disabled='formData.isCrm'
					placeholder="请输入公司名称" style='width: 450px;'></el-input>
				</el-form-item>

				<el-form-item label="会计准则：" >
					<el-select v-model="formData.accountingSystem" placeholder="请选择会计准则" size="small" style='width: 450px;' disabled>
						<el-option v-for = "item in accountingSystem" :value='item.type' :label='item.name' :key='item.id'></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="本位币：" >
					<el-input v-model="formData.standardCurrency" size="small" placeholder="请输入本位币" style='width: 450px;' disabled>
					</el-input>
				</el-form-item>

				<el-form-item label="账套启用：" >
					<el-date-picker v-model="formData.startYearPeriod" size="small" placeholder="请输入生效时间" style='width: 450px;' disabled></el-date-picker>
				</el-form-item>
				<el-form-item label="纳税人资格：" >
					<el-select v-model="formData.scale" placeholder="请选择会计准则" size="small" style='width: 450px;' :disabled = "formData.isCrm">
						<el-option v-for = "item in taxTypeList" :value='item.id' :label='item.label' :key='item.id'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否小微企业：">
						<el-switch
							v-model="formData.microEnterprise"
							active-text="是"
							inactive-text="否">
						</el-switch>
						<el-tooltip class="item" effect="dark"  placement="top">
							<div slot="content">
								<p>小型微利企业是指从事国家非限制和禁止行业，且同时符合年度应纳税所得额不超过300万元、从业人数不超过300人、</p>
								<p>资产总额不超过5000万元等三个条件的企业。(国家税务总局公告2019年第2号)</p>
							</div>
							<i class = "el-icon-warning-outline tip__i"></i>
						</el-tooltip>
				</el-form-item>
				
				<el-form-item label="科目编码等级：" >
					<el-select v-model="formData.subjectLevel"  size="small" style='width: 60px;' @change='handleSelectChange'>
						<el-option v-for='item in subjectLevel' :lable="item.level" :value="item.level" :key='item.level' :disabled="!item.use"></el-option>
					</el-select>
					<img src="static/icon/hitInfo.png" alt="注意" style='display: inline-block;margin: 0 0 2px 5px;'>
					<span class='hitInfo' style='font-size: 12px;color: #999;' >科目级次和长度调大后，不能再恢复到调整前的级次和长度，请谨慎操作！</span>
				</el-form-item>
				<el-form-item label=" 异常数据导入："  label-width="228px">
					  <el-radio-group v-model="formData.exceptionData">
							<el-radio :label="true">允许</el-radio>
							<el-radio :label="false">不允许</el-radio>
						</el-radio-group>
				</el-form-item>
				<el-form-item label="科目编码长度："  style='display: block;'>
					<el-select size="small" style='width: 60px;padding-right: 10px;'  v-for='(item,index) in formData.subjectLevel' :key='item' :disabled='item==1'  v-model="formData.codeLongs[item-1]" @change='handleSelectChanges(index,formData.codeLongs[item-1])'>
						<el-option v-for='i in options' :lable="i" :value="i" :key='i'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="默认首页：" style='display: block;' v-if='!formData.isCrm'>
					 <el-radio v-model="formData.defaultDisplay" label="1">老板界面</el-radio>
 					 <el-radio v-model="formData.defaultDisplay" label="2">会计界面</el-radio>
				</el-form-item>
				<el-form-item label="结账设置：" v-if='!formData.isCrm'>
					 <el-checkbox v-model="formData.toExamine" >需审核后结账</el-checkbox>
				</el-form-item>
				<el-form-item label="微信推送："  class='sendPicker'  v-if='isItemShow&&!formData.isCrm'>
					<div class='sendPicker_container'>
						<el-button type='text' style='text-decoration: underline;' class='sendPicker_button'>绑定管理员微信账号

							<el-card class='hoverTip'  v-loading='loading_card'>
								<div class='title'>
									微信扫码完成添加 <span style='font-weight: none;font-size: 14px;color:#999;display: block;'>{{timeText}}</span>
								</div>
								<div class='images_erweima' title="自动刷新" >
									<img :src="pictureURL" alt="二维码">
								</div>
								<div class='footer_s'>
									结账、重要日记账数据第一时间推送
								</div>

							</el-card>
						</el-button>

						<div class='SweepCodePartner'>
							<!-- <div class='title_p' v-if='partnerList.length'>
								已扫码的小伙伴
							</div> -->
							<div class='SweepCodePartner_con' >
								<!-- <el-scrollbar class="default-scrollbar" v-if='partnerList.length>4'>
									<div class='partner_item clearfix' v-for='i in partnerList' :key='i.openId'>
										<img :src="i.dPortrait.headimgurl" alt="">{{i.dPortrait.nickname}}
										<span class='fr' style='line-height: 35px;'>{{i.dPortrait.province?i.dPortrait.province:"未知"}}</span>
										<div class='x_model' @click='handleSeleteUser(i)'><i class='el-icon-delete'></i></div>
									</div>
								</el-scrollbar> -->
								<div class='partner_item clearfix' v-for='i in partnerList' :key='i.openId' >
										<img :src="i.dPortrait.headimgurl" alt="">{{i.dPortrait.nickname}}
										<!-- <span class='fr' style='line-height: 35px;'>{{i.dPortrait.province?i.dPortrait.province:"未知"}}</span> -->
										<div class='x_model' @click='handleSeleteUser(i)'
											v-if='isDeleteUser'
										><i class='el-icon-delete'></i></div>
								</div>
							</div>

						</div>
					</div>
				</el-form-item>
			</el-form>
			<div style='text-align: center; margin-top: 20px;'>
				<el-button 
					size='small' 
					style='width: 120px;' 
					:class='item.function=="save"?"minButton":"secondaryButton"' 
					v-for='item in buttonList' :key='item.id' 
					@click='handleSetingClick(item.function)'>
						{{item.name}}
				</el-button>
			</div>
		</div>

		<el-dialog
				:title="sureTitle"
				class='default-dialog'
				width='900px'
				:close-on-click-modal='false'
  				:visible.sync="dialogVisible">
  			<div style="width: 100%;overflow: hidden;" v-loading='resetLoading' element-loading-text='正在初始化，请耐心等待...'>
  			<div class='container' ref='container'>
	  			<div class='container1'>
					<div class="content">
		  				<p class='hit'>
							初始化账套后，系统将清除当前账套下以下数据，且该操作不可逆，请慎重！
						</p>
						<el-row>
							<el-col :span='12'>
								<p class='hitSure'>
									不会删除以下数据：
								</p>
								<p class='deleteItem'>
									<span>1.出纳模块日记账数据</span>
									<span>2.交叉分析模板配置</span>
									<span>3.出纳账户（但出纳账户关联的已删除的科目会被清空）</span>
									<span>4.系统设置中的微信绑定账户及推送配置</span>
								</p>
							</el-col>
							<el-col :span='12'>
								<p class='hitSure'>
									您即将 <span class='delete'>删除</span>：
								</p>
								<p class='deleteItem'>
									<span>1.所有录入的凭证</span>
									<span>2.所有设置下的数据（包括科目、辅助核算、币别、凭证字等）</span>
									<span>3.所有录入的期初数据</span>
									<span>4.所有生成的账簿、报表等数据</span>
									<span>5.所有资产模块数据</span>
									<span>6.所有发票模块数据</span>
								</p>
							</el-col>
						</el-row>

		  			</div>
		  			<div class='checkbox'>
		  				<el-checkbox v-model='isSureReadItem' >我已导出所有数据进行了备份，并了解即将产生的后果</el-checkbox>
		  				<el-button type='text' size='big' @click='next' class='nextBtn'>下一步 <i class='el-icon-right'></i></el-button>
		  			</div>
				</div>
				<div class='container2'>
					<el-form :model='modifyForm' ref='modifyForm' :rules='rulesForm' :inline='true' label-width='90px'>
						<el-form-item label='账套名称：' prop='alias'>
							<el-input style='width:260px; ' size='mini' placeholder='请输入账套名称' v-model='modifyForm.alias'></el-input>
						</el-form-item>
						<el-form-item label='会计制度：' prop='type'>
							<el-select v-model='modifyForm.type' style='width:260px; ' size='mini' >
								<el-option v-for = "item in accountingSystem" :value='item.type' :label='item.name' :key='item.id'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label='启用期间：' prop='startYearPeriod' style='margin-top: 10px;display: block;'>
							<el-date-picker
								style='width:260px'
							    v-model="modifyForm.startYearPeriod"
							    type="month"
							    placeholder="选择月"
							    size='mini'>
							</el-date-picker>
						</el-form-item>

					</el-form>

					<div class='footer'>
						<div class='reset'>
							<span>请输入 <span class='red'>RESET</span>  确认重置账套：</span>
							<el-input style='width:100px; ' size='mini' placeholder='RESET  ↵' v-model='modifyForm.key'></el-input>
						</div>
						<div class='submitBtn'>
							<el-button  size='small' @click='submitData' class='submitDataBtn secondaryButton'>重置账套</el-button>
							<el-button type='text' size='big' @click='nextBack' class='backBtn'>上一步 <i class='el-icon-back'></i></el-button>
						</div>
					</div>
	  			</div>
  			</div>

  			<div class='step'>
  				<el-steps :active="step" >
				  <el-step  icon="el-icon-info" ></el-step>
				  <el-step icon="el-icon-edit"></el-step>
				</el-steps>
  			</div>
  		</div>
		</el-dialog>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
export default {
	components:{
		publicTable
	},
	data(){
		return {
			SweepCodePartnerStyle:{
				height:"",
			},
			timemers: null,   //时间定时器
			timemers_p: null,   //时间定时器
			timeText:"",      // 失效时间提示
			loading_card:false,
			isQRshow: false,
			sureTitle:'确认初始化',
			gobleLoading:false,
			options:[1,2,3,4],
			modifyForm:{
				type:"",
				alias: "",
				bookId:"",
				startYearPeriod:"",
				key:""
			},
			taxTypeList:[
				{label: "小规模",id: "1"},
				{label: "一般纳税人",id: "2"},
				{label: "个体户",id: "3"},
			],
			rulesForm:{      // 表单规则
				alias:[{ required: true,  message:"名称不能为空！" }],
				type:[{ required: true,  message:"会计制度不能为空！" }],
				startYearPeriod:[{ required: true,  message:"开始日期不能为空！" }],
			},

			resetLoading: false,
			stepPage:1,
			step:1,      // 当前步数
			isSureReadItem: false,    // 是否了解初始化后的影响
			dialogVisible: false,     // 初始化账套弹框是否显示
			title:'这个是主页',
			formData:{
				exceptionData:false,// 异常数据导入
				bookName:'',      // 公司名字
				accountingSystem:'',       // 会计准则
				standardCurrency:'',        // 外币
				startYearPeriod: '',  // 账套生效时间
				lengthNum:[],
				defaultDisplay: '',        // 界面
				toExamine: false,       // 是否需要结账审核
				codeLongs:[], // 科目编码长度
				subjectLevel:'',  // 科目编码层级
				microEnterprise: true, // 是否是小微企业
				scale: '1', // 是否是小微企业
			},
			buttonList: [],        // 按钮组
			accountingSystem:[], // 会计制度
			subjectLevel:[],     // 科目层级
			updateVal:[],
			pictureURL:"",        // 二维码图片地址
			nowTime:'',
			partnerList:[],  // 扫码伙伴列表
			isItemShow:false,  // 是否有微信推送
			isDeleteUser:false,  // 是否可以删除用户

		}
	},
	created(){
		this.init();
	},
	mounted(){
		// let _ = this;
		// _.timemers_p = setInterval(()=>{
		// 			_.getPartnerList();
		// 		},1000)
	},
	methods:{
    // 获取科目等级
    getSubjectSelect() {
      this.subjectLevel = [];
      this.$http.post('import/getSubjectLevel',{}).then(res=>{
      	if(res&&res.data.code=="1") {
          this.subjectLevel = res.data.data;
      	}
      })
    },
		init(){
			const _ = this;
			_.getSystemSeting();
			_.getButtonAuthorize();
			_.getAccountSystem();
			_.getSubjectSelect();
			_.getQRcode();

			_.getWxButton();
		},
		// 请求微信扫码权限
		getWxButton() {
			const _ = this;
	        let params={
	          permissions:'ac:twocode:getAll,ac:twocode:delUser'
	        }
	         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
	            if(res && res.data.code == 1) {
	            	let datas = res.data.data;
	                 if(datas&&datas.length) {
	                 	this.isItemShow = datas.some(i=>{return i.permission==="ac:twocode:getAll"});
	                 	this.isDeleteUser = datas.some(i=>{return i.permission==="ac:twocode:delUser"});
	                 	if(this.isItemShow) {
	                 		this.getPartnerList();
	                 	}
	                 }else {
	                 	this.isItemShow=false // 是否有微信推送
						this.isDeleteUser=false // 是否可以删除用户
	                 }
	            }
	         })
		},
		// 删除小伙伴
		handleSeleteUser(row) {
			this.$http.post('twocode/delUser' ,{openId:row.openId}).then(res=>{
				if(res&&res.data.code==1) {
					this.$message.success(res.data.msg)
				}
			})
		},
		// 获取扫描伙伴列表
		getPartnerList() {
			this.$http.post('twocode/getAllUser' ,{}).then(res=>{
				if(res&&res.data.code=="1") {
					if(!res.data.data) {
						this.partnerList = [];
						return;
					}
					this.partnerList = res.data.data.map(i=>{
						i.dPortrait = JSON.parse(i.dPortrait);
						return i;
					});

					// if(this.partnerList.length>4){
					// 	this.SweepCodePartnerStyle.height = 46*4 +"px";
					// }else {
					// 	this.SweepCodePartnerStyle.height='100%';
					// }
				}else {
				}
			})
		},
		// 请求二维码
		getQRcode() {
			this.loading_card =true;
			// let baseURL;
			// if(process.env.NODE_ENV=="development") {
			// 	baseURL='http://192.168.1.98:8088/manko_weixin'
			// }else {
			// 	baseURL='http://wechat.goodaccount.cn'
			// }
			//   const instance = this.$http.create({
			//  		baseURL:baseURL,
			//  		headers:{
			//  			"Content-Type": "application/json"
			//  		}
			//  })
			this.$http.post('/twocode/getQrcode' ,{cid:sessionStorage.cid}).then(res=>{
					let _=this,time;
					clearInterval(this.timemers);
					if(!res.data.data && !res.data.data.expire_seconds) return;
					time = new Date((new Date()).getTime() + res.data.data.expire_seconds*1000); // res.data.expire_seconds
					this.timeText = this.zeroPush(time.getHours()) + ":" + this.zeroPush(time.getMinutes()) +":" + this.zeroPush(time.getSeconds()) + "前有效";
					setTimeout(()=>{
						_.loading_card = false;
					},100)
			  		if(res.data.data) {
			  			this.pictureURL ="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket="+ res.data.data.ticket;
			  		}
			  		this.timemers = setInterval(()=>{
			  			_.getQRcode();
			  		},res.data.data.expire_seconds*1000-5000)
			  })
		},
		zeroPush(val) {
			if(Number(val)<10) {
				val = '0'+val
			}
			return val;
		},
		// 科目编码长度改变
		handleSelectChanges(index,val) {
			const _=this;
			let params={
				level:index+1,
				codeLong:val
			};
			let updateVal = _.updateVal[index];
			_.$http.post('createAccountSet/changCodeLong' ,params).then(res=>{
				if(res&&res.data.code=="1") {
					this.updateVal = JSON.parse(JSON.stringify(this.formData.codeLongs));
				}else {
					_.formData.codeLongs.splice(index,1,updateVal)
				}
			})
		},
		// 获取科目编码层级参数改变
		handleSelectChange(val){
			let back = this.formData.codeLongs.length;
			let dataNum = this.formData.subjectLevel-back;
			if(dataNum>=0){
				for(let i=0;i<dataNum;i++){
					this.formData.codeLongs.push(2);
				}
			}else {
				this.formData.codeLongs.splice(dataNum)
			}

			this.updateVal = JSON.parse(JSON.stringify(this.formData.codeLongs));
		},
		// 获取科目编码层级
		getSubjectLevel(){
			const _ = this;
			_.$http.post('sys/dict/list' ,{type:'subject_level'}).then(res=>{
				if(res&&res.data.code=="1") {
					_.subjectLevel = res.data.data.map(item=>{
						item.value = Number(item.value);
						return item;
					});
				}
			})
		},
		// 提交
		submitData() {
			const _ = this;
			if(!_.modifyForm.key) {
				return _.$message.warning("请输入 RESET 以最后确认初始化账套！")
			}
			_.$refs.modifyForm.validate((valid)=>{
				if(valid) {
					let params = JSON.parse(JSON.stringify(_.modifyForm));
					params.startYearPeriod = _.$util.formatDate.format(params.startYearPeriod , 'yyyMM')
					_.resetLoading = true;
					try {
						_.$http.post('createAccountSet/resetAccountCover' ,params).then(res=>{
							_.resetLoading = false;
							if(res&&res.data.code=="1") {
								_.$message.success(res.data.msg);

								// 重新获取菜单树
								this.$http.post('sys/menu/getTree',{}).then((msg)=>{
									if(msg && msg.data.code == '1'){
										this.$store.commit('ADDROUTECHILD' , msg.data.data)
										this.$setSessionStorage('menu',msg.data.data);
										location.reload()
									}
								});
							}
						})
					}catch(e) {
						console.log(e);
						_.resetLoading = false;
					}
				}
			})
		},
		// 获取会计制度
		getAccountSystem() {
			this.$http.post('sys/accounting/list' , {}).then(res=>{
				this.accountingSystem = res.data.data;
			})
		},
		handleSetingClick(type) {

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			if(type=="save") {
				this.handleEventSave();
			}else {
				this.dialogVisible = true;
			}
		},
		// 保存
		handleEventSave() {
			const _ = this;
			if(_.formData.bookName==="") {
				return this.$message.warning("公司名称不能为空！")
			}
			let params={
				level:_.formData.subjectLevel,
				codeLongs:_.formData.codeLongs.toString(),
				defaultDisplay:_.formData.defaultDisplay,
				isCheck:_.formData.toExamine,
				bookName:_.formData.bookName,
				microEnterprise:_.formData.microEnterprise,
				scale:_.formData.scale,
				exceptionData:_.formData.exceptionData
			};
			_.gobleLoading = true;
			_.$http.post('createAccountSet/settingUpdate',params).then(res=>{
				_.gobleLoading = false;
				if(res&&res.data.code=="1") {
					this.$emit('successSaves',true)
					_.$message.success("修改成功！")
				}
			})
		},
		// 下一步
		next() {
			if(!this.isSureReadItem) {
				return this.$message.warning('请确认已清楚了解即将产生的后果！')
			}
			this.sureTitle = '请预设重置后的账套信息';
			this.$refs.container.style.transform = 'translateX(-865px)'
			this.$refs.container.style.transition = 'all .2s linear';
			this.step = 2;
			this.stepPage = 2;
		},
		// 上一步
		nextBack() {
			this.sureTitle = '确认初始化';
			this.$refs.container.style.transform = 'translateX(0px)'
			this.$refs.container.style.transition = 'all .2s linear';
			this.step = 1;
			this.stepPage = 1;
		},
		// 获取系统设置
		getSystemSeting() {
			const _ = this;
			_.$http.post('createAccountSet/getSystemSetting',{}).then(res=>{
				if(res&&res.data.code=="1") {
					_.formData = Object.assign({},_.formData,res.data.data);
					_.formData.subjectLevel = _.formData.codeLongs.length;
					_.updateVal = JSON.parse(JSON.stringify(_.formData.codeLongs));
					// for(let i=0;i<_.formData.codeLongs.length+1;i++) {
					// 	_.formData.lengthNum.push(null)
					// }
					_.modifyForm = Object.assign( {} , _.modifyForm , {
						type:res.data.data.accountingSystem,
						alias: res.data.data.bookName,
						bookId:res.data.data.bookId,
						startYearPeriod:res.data.data.startYearPeriod
					})
				}
			})
		},
		// 获取初始化、保存按钮
	      getButtonAuthorize() {
	        const _ = this;
	        let params={
	          permissions:'sys:init:account,sys:seting:save'
	        }
	         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
	            if(res && res.data.code == 1) {
	              _.buttonList = res.data.data;
	            }
	         })
	      },
		saveUpdateCompany(){
			const _=this;

		}
	},
	activated(){
		this.getSystemSeting();
		//this.getQRcode();
		let _ = this;
		if(this.isItemShow) {
	 		_.timemers_p = setInterval(()=>{
					_.getPartnerList();
				},1000)
	 	}

	},
	 deactivated() {
       //clearInterval(this.timemers);
       clearInterval(this.timemers_p);
    },
	watch: {
		dialogVisible(val) {
			if(val) {
				this.sureTitle = '确认初始化';
				this.isSureReadItem = false;
				this.nextBack();
			}
		},
		// isQRshow(val) {
		// 		let _ = this;
		// 	if(val) {
		// 		_.timemers_p = setInterval(()=>{
		// 			_.getPartnerList();
		// 		},1000)
		// 	}else {
		// 		clearInterval(_.timemers_p);
		// 	}
		// }

	}
}
</script>

<style lang="less">
	#companyAttributes{
		.tip__i {
			transform: translateY(1px);
			margin-left: 5px;
		}
		 .el-scrollbar__wrap,.default-scrollbar__wrap {
		      overflow-x: hidden;
		    }
		 .default-scrollbar {
		      width: 100%;
		      height: 100%;

		   }

		 .fade-enter,.fade-leave-to {
            opacity: 0;
            transform: translateY(-30px);
        }
        .fade-enter-active ,.fade-leave-active {
            transition: all .1s linear;
        }
		.sendPicker {
			display: block;
			width: 100%;
			.sendPicker_container {

				.sendPicker_button {
					position: relative;
					&:hover {
						.hoverTip {
							display: block;
						}
					};
				}
				.SweepCodePartner {
					margin-top: 0px;
					width: 550px;
					.SweepCodePartner_con {
						overflow: hidden;

					}
					.title_p {
						font-weight: 600;
						color:#666;
					}
					.partner_item {
						position: relative;
						padding: 5px 0;
						display: inline-block;
						cursor: pointer;
						margin-right: 10px;
						&:hover {
								.x_model{
									display:block;
								}
							};
						img {
							display: inline-block;
							border-radius: 50%;
							width: 30px;
							margin-right: 10px;

						}
						.x_model {
							position: absolute;
							left: 0;
							top: 10px;
							width: 30px;
							height: 30px;
							border-radius: 50%;
							background:rgba(0,0,0,.3);
							text-align:center;
							line-height: 30px;
							display: none;
							i {
								color: red;
								font-weight: 600;
							}
						}
					}
				}


			}
			.hoverTip {
				line-height: 20px;
				width: 300px;
				position: absolute;
				top: -50px;
				z-index: 999;
				display: none;
				right: -320px;
				.images_erweima {
					width: 150px;
					margin: 0 auto;
					cursor: pointer;
					img {
						width: 100%;
					}
				}
				.title {
					text-align: center;
					font-size: 16px;
					font-weight: 600;
				}
				.footer_s {
					text-align: center;
				}
			}
		}
		.red {
			color: red;
			font-weight: bold;
		}
		 .el-input--small .el-input__inner {
	        height: 32px !important;
	        line-height: 32px;
	    }
	    .hit {
	    	color: red;
	    	font-weight: bold;
	    	font-size: 16px;
	    }
	    .hitSure {
	    	font-size: 16px;
	    	margin: 20px 0;
	    	.delete {
	    		color: red;
		    	font-size: 16px;
	    	}
	    }
	    .deleteItem {
	    	margin-left: 20px;
	    	span {
	    		display: block;
	    		font-size: 14px;
	    		padding: 2px 0
	    	}
	    }
	    .checkbox {
	    	margin: 20px 0;
	    	width: 100%;
	    	text-align: center;
	    	position: relative;
	    		.nextBtn {
	    			display: block;
			    	position: absolute;
			    	right: 100px;
			    	top: 20px;
			    	font-weight: bold;
			    	i{
			    		font-size: 16px;
			    		font-weight: bold;
			    	}
			    }
	    }
	    .container{
	    	height: 350px;
	    	width: 1800px;
	    	vertical-align: top;
	    	.container1,.container2 {
	    		width: 860px;
	    		height: 100%;
	    		overflow: hidden;
	    		display: inline-block;

	    	}
	    }
	    .footer {
	    	margin: 30px 0;
	    	.reset {
	    		line-height: 28px;
	    		user-select:none;
	    		text-align: center;
	    	}
	    	.submitBtn {
	    		text-align: center;
	    		margin-top: 10px;
	    		position: relative;
	    		.submitDataBtn {
	    			width: 200px;
	    			margin-top: 10px;
	    		}
	    		.backBtn {
	    			display: block;
			    	position: absolute;
			    	right: 100px;
			    	top: 150px;
			    	font-weight: bold;
			    	i{
			    		font-size: 16px;
			    		font-weight: bold;
			    	}
	    		}
	    	}
	    }

	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/companyAttributes.vue